<template>
  <div class="inline-flex items-center justify-center w-full">
    <div
      v-for="n in stars"
      :key="n"
      class="relative"
      :class="{ 'cursor-pointer': !disabled }">
      <XIcon
        name="fa/light/star"
        class="leading-none"
        :class="starClass" />

      <div
        class="absolute pin-t pin-l"
        :class="{ [starActiveClass]: n <= starRating, 'text-transparent': n > starRating }"
        @mouseover="setRating($event, n)"
        @mouseleave="setRating"
        @click="emitInput">
        <XIcon
          name="fa/solid/star"
          class="leading-none" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stars: {
      type: Number,
      default: 5
    },
    value: {
      type: Number,
      required: true
    },
    starClass: {
      type: [String, Array, Object],
      default: ''
    },
    starActiveClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      starRating: this.value
    }
  },

  watch: {
    value: function (newVal) {
      this.starRating = newVal
    }
  },

  methods: {
    setRating (event, number = null) {
      if (!this.disabled) {
        this.starRating = number || this.value
      }
    },

    emitInput () {
      if (!this.disabled) {
        this.$emit('input', this.starRating)
        this.$emit('change', { value: this.starRating, stars: this.starts })
      }
    }
  }
}
</script>
